import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/OrderBilling.requests'
import simpleApi from 'app/services/simpleApi'

const useRemovePosition = (onSuccess: () => void) => {
    const token = useJWTToken()
    const {
        onError,
    } = useHandleStatusRequest({
        id: 'removePosition',
    })

    return useMutation({
        mutationFn: ({
            invoiceId,
            positionId,
        }: {
            invoiceId: number,
            positionId: number,
        }) => {
            return simpleApi({
                ...requests.deletePosition({
                    outgoingInvoiceId: invoiceId,
                    positionId,
                }),
                token,
            })
        },
        onSuccess,
        onError,
    })
}

export default useRemovePosition
